import React from 'react'
import { useState, useEffect } from 'react'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { Collapse } from 'antd'
import ContactStyle from '../../styles/Contact.module.css'

const { Panel } = Collapse

const FAQContact = ({ env }) => {
  const [envShort, setEnvShort] = useState("")

  useEffect(() => { 
    switch(env) {
      case "Staging":
        setEnvShort("stg")
        break;
      case "Prepublish":
        setEnvShort("prep")
        break;
    }
  }, [])
  return (
    <>
      <Collapse
        className={ContactStyle.faqContactCollapse}
        expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
        expandIconPosition="right"
        style={{background: "white", border: "none"}}
      >
        <Panel
          key="1"
          header={
            <p>
              How can I contact CURE <span style={{fontWeight: 'bold'}}>Customer Service</span>?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            You can contact our customer service by phone:{' '}
            <a target="_blank" rel="noopener noreferrer" href="tel:+18005352873" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              800-535-2873
            </a>
            {' '}or through our{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://chat${envShort}.cure.com`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              live chat
            </a>
            {' '}for assistance.
          </p>
        </Panel>

        <Panel
          key="2"
          header={
            <p>
              How do I <span style={{fontWeight: 'bold'}}>access my account online</span>?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            Visit{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/my-account`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              My Account
            </a>
            {' '}to view policy details and make adjustments 24/7.
          </p>
        </Panel>

        <Panel
          key="3"
          header={
            <p>
              What are my <span style={{fontWeight: 'bold'}}>payment options</span> with CURE auto insurance?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            You can make an{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://payments${envShort}.cure.com`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              online payment
            </a>
            {' '}anytime using your checking or savings account, credit or debit card, or digital wallet for quick and secure processing.
          </p>
        </Panel>

        <Panel
          key="4"
          header={
            <p>
              Does CURE have a <span style={{fontWeight: 'bold'}}>mobile app</span>?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            Yes - download the free CURE mobile app on your{' '}
            <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/us/app/cure-auto-insurance/id1640122356" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              Apple device
            </a>
            {' '}or your{' '}
            <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.vazkordev.CureApp&hl=en_US&pli=1" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              Android device
            </a>
            {' '}to manage your policy, make payments, access your ID cards and more anytime.
          </p>
        </Panel>

        <Panel
          key="5"
          header={
            <p>
              In what <span style={{fontWeight: 'bold'}}>states</span> is CURE auto insurance available?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            CURE auto insurance is currently available to drivers in Michigan, New Jersey and Pennsylvania.
          </p>
        </Panel>
      </Collapse>

      <Collapse
        className={ContactStyle.faqContactCollapse}
        expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
        expandIconPosition="right"
        style={{background: "white", border: "none"}}
      >
        <Panel
          key="6"
          header={
            <p>
              How do I <span style={{fontWeight: 'bold'}}>retrieve my saved insurance quote</span> from CURE?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            Simply{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://getquote${envShort}.cure.com/retrieve-saved-quote.aspx`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              click here
            </a>
            {' '}to review your quote and complete your insurance application. You will need your email address associated with your quote, your zip code, and your quote number.
          </p>
        </Panel>

        <Panel
          key="7"
          header={
            <p>
              How do I <span style={{fontWeight: 'bold'}}>add a new vehicle</span> to my existing CURE car insurance policy?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            To add a vehicle, simply{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/my-account`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              log in to My Account
            </a>
            {' '}or call our Customer Service at{' '}
            <a target="_blank" rel="noopener noreferrer" href="tel:+18005352873" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              800-535-2873
            </a>
            , and we'll help update your policy.
          </p>
        </Panel>

        <Panel
          key="8"
          header={
            <p>
              How do I <span style={{fontWeight: 'bold'}}>report a car insurance claim</span> to CURE?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            You can report a claim anytime - either by logging into{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/my-account`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              My Account
            </a>
            ,{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/claims/fnol-form`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              submitting a claim online
            </a>
            , or calling our dedicated claims line at{' '}
            <a target="_blank" rel="noopener noreferrer" href="tel:+18002299151" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              800-229-9151.
            </a>
          </p>
        </Panel>

        <Panel
          key="9"
          header={
            <p>
              How does the <span style={{fontWeight: 'bold'}}>claims process</span> work?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            Once you report a claim and submit the requested documents, you will be assigned a dedicated CURE claims representative and can expect to hear from them within 1-2 business days. They will help you navigate through the claims process and be available to answer any questions.
          </p>
        </Panel>

        <Panel
          key="10"
          header={
            <p>
              How do I request <span style={{fontWeight: 'bold'}}>roadside assistance</span> 24/7?
            </p>
          }
          style={{ 
            fontSize: '1.2rem', 
            border: "none"
          }}
        >
          <p>
            You can request roadside assistance through the{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/download-mobile-app`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              CURE mobile app
            </a>
            {' '}or by calling{' '}
            <a target="_blank" rel="noopener noreferrer" href="tel:+18665221991" style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              866-522-1991
            </a>
            .{' '}
            <a target="_blank" rel="noopener noreferrer" href={`https://${env === 'Production' ? 'www' : env}.cure.com/roadside`} style={{textDecoration: 'underline', color: 'rgb(55, 105, 152)'}}>
              Click here to learn more.
            </a>
          </p>
        </Panel>
      </Collapse>
    </>
  )
}

export default FAQContact
